import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Documento from "model/documentos/Documento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    pasta: DocumentoPasta
    onConfirm: () => void;
}

const documentoPastaService = new DocumentoPastaService();
export default function ModalPastaMover(props: Props) {
    const [pastaSelecionada, setPastaSelecionada] = useState<DocumentoPasta>(props.pasta.pastaMae || new DocumentoPasta(0, '(Raiz)', null));
    const [pastas, setPastas] = useState<DocumentoPasta[]>([]);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm() {
        if (!pastaSelecionada.nome || pastaSelecionada.nome.trim() === '') {
            msgAlerta("Erro", "O nome da pasta não pode ser vazio.");
            return;
        }

        startLoading();
        documentoPastaService.moverPasta(props.pasta.id, pastaSelecionada.id).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao mover", error?.data?.message || "Erro ao mover pasta");
            console.error("Erro ao mover pasta:", error);
        });

    }

    useEffect(() => {
        documentoPastaService.buscarTodas().then((json) => {
            json.unshift(new DocumentoPasta(0, '(Raiz)', null))
            setPastas(json);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
        });
    }, [])

    return (
        <Dialog
            header="Mover Pasta"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Mover" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                <Label>Pasta</Label>
                <div>
                    <span>{props.pasta.nome}</span>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label>Pasta mãe</Label>
                <Dropdown
                    value={pastaSelecionada}
                    onChange={(e) => setPastaSelecionada(e.value)}
                    options={pastas}
                    optionLabel="nome"
                    dataKey="id"
                />
            </div>

        </Dialog>
    );
}